// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2Tv6I","headInfo":"styles_headInfo__UveLe","siteName":"styles_siteName__aqxo5"};